import { render, staticRenderFns } from "./BlogSinglePost.vue?vue&type=template&id=c06648ae&"
import script from "./BlogSinglePost.vue?vue&type=script&lang=ts&"
export * from "./BlogSinglePost.vue?vue&type=script&lang=ts&"
import style0 from "./BlogSinglePost.vue?vue&type=style&index=0&id=c06648ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogSinglePostAuthor: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/blog/single-post/BlogSinglePostAuthor.vue').default})
